__turbopack_context__.v({
  "currentPageLink": "nav-link-module__0FpC2W__currentPageLink",
  "link": "nav-link-module__0FpC2W__link",
  "mobileLinks": "nav-link-module__0FpC2W__mobileLinks",
  "root": "nav-link-module__0FpC2W__root",
  "tagWrapper": "nav-link-module__0FpC2W__tagWrapper",
});
